import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useObservable} from '@ngneat/react-rxjs';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';

import {suppliersServicesQuery, suppliersServicesService} from '@store/suppliers/services';

import {Add, Download, GroupAction} from '@icons/index';

import SuppliersServicesTable from '@screens/admin/suppliers/services/SuppliersServices.table';

const SuppliersServicesTab = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [selectedSuppliersServices] = useObservable(suppliersServicesQuery.selectedSuppliersServices$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    suppliersServicesService.getSuppliersServicesCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} width="100%" spacing={2} mt="-35px">
      <Stack alignSelf="flex-end" direction="row" alignItems="center" spacing={2}>
        <Button
          variant="outlined" color="primary"
          disabled={!selectedSuppliersServices.length}
          startIcon={<GroupAction/>}>
          {t('global.groupedAction')}
        </Button>
        <Button
          variant="outlined" color="primary"
          disabled={CSVLoading}
          onClick={handleExportCSV}
          startIcon={<Download/>}>
          {t('global.exportCSV')}
        </Button>
        <Button
          variant="contained" color="primary"
          onClick={() => navigate('add')}
          startIcon={<Add/>}>
          {t('suppliers.addButtons.service')}
        </Button>
      </Stack>
      <Stack flex={1}>
        <SuppliersServicesTable/>
      </Stack>
    </Stack>
  );
};

export default SuppliersServicesTab;
